import type { Context } from 'react';
import { createContext, useContext } from 'react';

import type { ExternalLinkClickHandler } from './ExternalLink.types';

export const ExternalLinkClickHandlerContext: Context<ExternalLinkClickHandler | undefined> = createContext<
  ExternalLinkClickHandler | undefined
>(undefined);

type UseExternalLinkClickHandlerContext = () => ExternalLinkClickHandler | undefined;
export const useExternalLinkClickHandlerContext: UseExternalLinkClickHandlerContext = () =>
  useContext(ExternalLinkClickHandlerContext);
